import { BaseRepository } from './BaseRepository'

/**
 * TaskEvidenceRepository — re-implementacion limpia (SQL) de task.evidence de v1
 * src/offline/modules/task-actions.js (REFERENCIA — NO importado).
 *
 * Tabla `task_evidence`, entity `task`, pk `uuid` (NO client_uuid). La evidencia es un
 * EVENT: NO se coalesce — cada pieza de evidencia es una fila de outbox propia. body
 * NORMALIZADO: solo refs (image_ref/local_path), NUNCA el binario (F5 lo resuelve al
 * drenar). La marca evsent:<uuid> la escribe F3 al exito — NO aqui.
 */
export class TaskEvidenceRepository extends BaseRepository {
  constructor () {
    super('task_evidence', 'task', 'uuid')
  }

  /**
   * Anade una pieza de evidencia (EVENT, no coalesce).
   * @param {object} evRow  fila de evidencia (incluye uuid, task_client_uuid, kind, ...).
   * @returns {Promise<string>} uuid de la evidencia.
   */
  async addEvidence (evRow = {}) {
    const uuid = evRow.uuid
    return this.saveOptimistic({
      clientUuid: uuid,
      dataRow: { ...evRow },
      op: 'task.evidence',
      coalesce: false,
      body: {
        task_client_uuid: evRow.task_client_uuid,
        uuid,
        kind: evRow.kind,
        image_ref: evRow.image_ref,
        comment: evRow.comment,
        filename: evRow.filename
      }
    })
  }
}

export const taskEvidenceRepository = new TaskEvidenceRepository()
